// Storefront v2 collection page (stage 09): filters and sort re-render the section through the
// Section Rendering API (the form works as a plain GET without JS), pill/clear links do the same,
// and "load more" appends the next page's cards. No copy in here.

const root = () => document.querySelector('[data-am-coll]');

async function fetchSection(url, sectionId) {
  const u = new URL(url, window.location.origin);
  u.searchParams.set('section_id', sectionId);
  const res = await fetch(u, { headers: { Accept: 'text/html' } });
  if (!res.ok) throw new Error(`section ${res.status}`);
  return new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('[data-am-coll]');
}

/** Swap the whole section for the one rendered at `url`, keep the mobile sheet and focus where they were. */
async function render(url, { push = true } = {}) {
  const current = root();
  if (!current) return;
  const sheet = current.querySelector('am-dialog.am-rail');
  const sheetOpen = sheet?.isOpen;
  const focusName = document.activeElement?.name;
  const focusValue = document.activeElement?.value;
  current.setAttribute('aria-busy', 'true');
  try {
    const next = await fetchSection(url, current.dataset.section);
    if (!next) throw new Error('no section');
    if (sheetOpen) {
      // keep the open dialog element (its focus trap and opener), refresh only its contents
      const nextPanel = next.querySelector('am-dialog.am-rail [data-am-panel]');
      next.querySelector('am-dialog.am-rail').replaceWith(sheet);
      sheet.querySelector('[data-am-panel]').replaceWith(nextPanel);
    }
    current.replaceWith(next);
    if (sheetOpen) sheet.relock?.(); // the rest of the new section must be inert again
    if (push) window.history.pushState({ amColl: true }, '', url);
    if (focusName) {
      const el = next.querySelector(`[name="${CSS.escape(focusName)}"][value="${CSS.escape(focusValue || '')}"]`);
      el?.focus();
    }
  } catch {
    window.location.href = url; // fall back to a normal navigation
  } finally {
    root()?.removeAttribute('aria-busy');
  }
}

function urlFromForm(form) {
  const params = new URLSearchParams();
  for (const [k, v] of new FormData(form)) params.append(k, String(v));
  const sort = document.querySelector('[data-am-sort]');
  if (sort) params.set('sort_by', sort.value);
  const u = new URL(form.action, window.location.origin);
  u.search = params.toString();
  return u.toString();
}

document.addEventListener('change', (e) => {
  const form = e.target.closest('[data-am-filters]');
  if (form) return void render(urlFromForm(form));
  if (e.target.matches('[data-am-sort]')) {
    const f = document.querySelector('[data-am-filters]');
    if (f) render(urlFromForm(f));
  }
});

document.addEventListener('click', async (e) => {
  const link = e.target.closest('[data-am-filter-link]');
  if (link && root()?.contains(link)) {
    e.preventDefault();
    return void render(link.href);
  }
  const more = e.target.closest('[data-am-load-more]');
  if (more) {
    e.preventDefault();
    const box = more.closest('[data-am-more]');
    box.setAttribute('aria-busy', 'true');
    try {
      const next = await fetchSection(more.href, root().dataset.section);
      const grid = root().querySelector('[data-am-grid]');
      grid.append(...next.querySelectorAll('[data-am-grid] > li:not(.am-coll__editorial)'));
      box.replaceWith(next.querySelector('[data-am-more]'));
      window.history.replaceState({ amColl: true }, '', more.href);
    } catch {
      window.location.href = more.href;
    }
  }
});

window.addEventListener('popstate', (e) => {
  if (e.state?.amColl) render(window.location.href, { push: false });
});
